export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-stone-950 px-8 md:px-20 py-12">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <p className="text-stone-400 text-sm font-medium mb-1">OSMICA, d.o.o.</p>
          <p className="text-stone-600 text-xs">
            &copy; {new Date().getFullYear()} OSMICA, d.o.o. All rights reserved.
          </p>
        </div>

        <nav className="flex flex-wrap gap-6">
          {[
            { label: 'Home', href: '#home' },
            { label: 'About', href: '#about' },
            { label: 'Products', href: '#products' },
            { label: 'Contact', href: '#contact' },
          ].map((item) => (
            <button
              key={item.label}
              onClick={() => handleNav(item.href)}
              className="text-stone-500 hover:text-stone-300 text-xs uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </nav>
      </div>
    </footer>
  );
}
